// extracted by mini-css-extract-plugin
export default {"root":"workforce_member_column-module___root___c2a6c9cb"};